// Importer la fonction showNotification depuis le module dédié
import { showNotification, storeNotification } from './notifications.js';

const FormService = {
    async submitInscription(formData, eventId) {
        console.log('Début de la soumission de l\'inscription');
        
        try {
            // Ajouter les données nécessaires pour la requête AJAX
            formData.append('action', 'gobooking_submit_inscription');
            formData.append('nonce', goBookingData.nonce);
            formData.append('event_id', eventId);

            console.log('URL AJAX:', goBookingData.ajax_url);
            console.log('Nonce:', goBookingData.nonce);
            
            // Afficher les données du formulaire pour débogage
            console.log('Données du formulaire:');
            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }

            // Effectuer la requête AJAX
            const response = await fetch(goBookingData.ajax_url, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin' // Assurer que les cookies sont envoyés
            });

            console.log('Statut de la réponse:', response.status, response.statusText);
            
            if (!response.ok) {
                const statusError = `Erreur HTTP: ${response.status} - ${response.statusText}`;
                console.error(statusError);
                throw new Error(statusError);
            }

            // Tenter de traiter la réponse JSON
            let result;
            try {
                result = await response.json();
                console.log('Réponse du serveur:', result);
            } catch (jsonError) {
                console.error('Erreur lors du parsing JSON:', jsonError);
                const responseText = await response.text();
                console.log('Réponse brute du serveur:', responseText);
                throw new Error('Erreur lors du traitement de la réponse du serveur');
            }

            if (result.success) {
                console.log('Inscription soumise avec succès');
                showNotification('success', 'Votre inscription a été enregistrée avec succès');
                // Stocker la notification pour l'afficher après le rechargement
                storeNotification('success', 'Votre inscription a été enregistrée avec succès');
                return true;
            } else {
                console.error('Erreur lors de la soumission:', result.data);
                const errorMessage = result.data.message || 'Une erreur est survenue lors de l\'inscription';
                showNotification('error', errorMessage);
                // Stocker la notification d'erreur pour l'afficher après le rechargement
                storeNotification('error', errorMessage);
                return false;
            }
        } catch (error) {
            console.error('Erreur détaillée lors de la soumission:', error);
            console.error('Stack trace:', error.stack);
            
            let errorMessage = 'Une erreur est survenue lors de la soumission du formulaire';
            if (error.message) {
                errorMessage += ': ' + error.message;
            }
            
            showNotification('error', errorMessage);
            // Stocker la notification d'erreur pour l'afficher après le rechargement
            storeNotification('error', errorMessage);
            return false;
        }
    },

    validateForm(form) {
        const requiredFields = form.querySelectorAll('[required]');
        let isValid = true;

        requiredFields.forEach(field => {
            if (!field.value.trim()) {
                this.showFieldError(field, 'Ce champ est obligatoire');
                isValid = false;
            } else if (field.type === 'email' && !this.validateEmail(field.value)) {
                this.showFieldError(field, 'Veuillez entrer une adresse email valide');
                isValid = false;
            } else if (field.type === 'tel' && !this.validatePhone(field.value)) {
                this.showFieldError(field, 'Veuillez entrer un numéro de téléphone valide');
                isValid = false;
            } else {
                this.clearFieldError(field);
            }
        });

        return isValid;
    },

    showFieldError(field, message) {
        const errorDiv = field.nextElementSibling?.classList.contains('field-error')
            ? field.nextElementSibling
            : document.createElement('div');
        
        if (!field.nextElementSibling?.classList.contains('field-error')) {
            errorDiv.className = 'field-error text-danger';
            field.parentNode.insertBefore(errorDiv, field.nextSibling);
        }
        
        errorDiv.textContent = message;
        field.classList.add('is-invalid');
    },

    clearFieldError(field) {
        const errorDiv = field.nextElementSibling;
        if (errorDiv?.classList.contains('field-error')) {
            errorDiv.remove();
        }
        field.classList.remove('is-invalid');
    },

    validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },

    validatePhone(phone) {
        return /^(\+33|0)[1-9](\d{2}){4}$/.test(phone);
    },

    serializeForm(form) {
        const formData = new FormData(form);
        const serialized = {};

        for (let [key, value] of formData.entries()) {
            // Gestion des tableaux (ex: participants[0][nom])
            if (key.includes('[')) {
                const matches = key.match(/([^\[]+)\[(\d+)\]\[([^\]]+)\]/);
                if (matches) {
                    const [, array, index, field] = matches;
                    if (!serialized[array]) serialized[array] = [];
                    if (!serialized[array][index]) serialized[array][index] = {};
                    serialized[array][index][field] = value;
                }
            } else {
                serialized[key] = value;
            }
        }

        return serialized;
    }
};

export default FormService; 